// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__huRP3","header":"MergedInvoice_header__eSTxc"};